import React from 'react';

const ModalThumbDown = ({
  row,
  feedbackInteractionNotes,
  setFeedbackInteractionNotes,
  InteractionFeedbackRequest,
  closeModal,
}) => {
  const handleSendFeedback = () => {
    InteractionFeedbackRequest('thumb-down', row.botMessage.interactionCode);
    closeModal();
  };

  return (
    <div
      id={`modal-invia-feedback-${row.botMessage.interactionCode}`}
      className="modal-clear-history-overlay modal-clear-history-show"
      style={{ zIndex: '99999999999999' }}
    >
      <div className="modal-clear-history-modal">
        {/* Header */}
        <div className="modal-clear-history-header">
          <button
            className="modal-clear-history-close-button"
            onClick={closeModal}
            style={{ color: 'black' }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="modal-clear-history-body">
          <label
            className="form-label"
            htmlFor={`feedback-textarea-${row.botMessage.interactionCode}`}
            style={{
              display: 'block',
              fontWeight: '500',
              marginBottom: '8px',
            }}
          >
            Note (facoltativo)
          </label>
          <textarea
            id={`feedback-textarea-${row.botMessage.interactionCode}`}
            className="form-control"
            style={{
              width: '100%',
              minHeight: '200px',
              padding: '10px',
              fontSize: '14px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              resize: 'vertical',
            }}
            placeholder="Inserisci delle specifiche su come potrebbe essere migliorata la risposta"
            value={feedbackInteractionNotes}
            onChange={(e) => setFeedbackInteractionNotes(e.target.value)}
          />
        </div>

        {/* Footer */}
        <div className="modal-clear-history-footer">
          <button
            className="modal-clear-history-button modal-clear-history-cancel"
            onClick={closeModal}
          >
            Annulla
          </button>
          <button
            className="modal-clear-history-button modal-clear-history-confirm"
            onClick={handleSendFeedback}
          >
            Invia feedback
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalThumbDown;
